/**
 * Central color tokens - change values here only.
 * Import via theme.js
 * use getProjectTheme() for project palettes.
 */

const brand = {
  accent: "#bcdbed",
  accentContent: "#03324F",
  accentLight: "#E7F2F9",
  accentDark: "#022840",
  accentBorder: "#03324F",
};

const linkHover = { light: "#25a1ee", dark: "#066dae" };
const clickIcon = "#62acda";

const neutrals = {
  white: "#fff",
  black: "#000",
  medium: "#d9dbe1",
  grey: {
    dark: "#0b0d17",
    darkMedium: "#72747e",
    medium: "#d9dbe1",
  },
};

const surface = "#f2f9fd";

const availability = {
  background: "#77d072",
  content: "#112e0f",
};

const shadow = {
  // Used for project card / cover shadows across the site.
  card: "17px 17px 48px 0 rgb(0 0 0 / 12%)",
};

const form = {
  error: "#f36868",
  border: "#C6DDEB",
  borderHover: brand.accentContent,
  cardBackground: neutrals.white,
  inputBackground: neutrals.white,
};

const code = {
  background: brand.accentLight,
  border: "#C6DDEB",
};

/**
 * Per-project theme:
 * - title: dark accent for project titles / category labels
 * - card: light tint for homepage project cards and testimonial cards
 */
const projectThemes = {
  default: {
    title: brand.accentContent,
    card: surface,
  },
  "condexo-pay": {
    title: brand.accentContent,
    card: "#F0F8FF",
  },
  "condexo-property-management": {
    title: "#0D5C52",
    card: "#F0FFFD",
  },
  "harmindra-international": {
    title: "#1A5276",
    card: "#F0F6FF",
  },
  shakespeers: {
    title: "#3F6212",
    card: "#F4F7EB",
  },
  meltwater: {
    title: "#C54B2A",
    card: "#FFF5F0",
  },
  jiffy: {
    title: "#5A3E7A",
    card: "#F5F0FF",
  },
  "blank-canvas-dao": {
    title: brand.accentContent,
    card: neutrals.white,
  },
  "blank-auction-house": {
    title: brand.accentContent,
    card: neutrals.white,
  },
};

const getProjectTheme = (slug) => projectThemes[slug] || projectThemes.default;

const colors = {
  ...brand,
  clickIcon,
  body: "rgba(41, 41, 41, 1)",
  error: form.error,
  ...neutrals,
  surface,
  availability,
  brand,
  linkHover,
  shadow,
  form,
  code,
  projectThemes,

  // Legacy aliases (prefer getProjectTheme / brand / form)
  peach: projectThemes.meltwater.title,
  peachLight: projectThemes.meltwater.card,
  blue800: brand.accentBorder,
  blue900: brand.accentDark,
  projectCard: {
    condexoPay: projectThemes["condexo-pay"].card,
    condexoProperty: projectThemes["condexo-property-management"].card,
    harmindra: projectThemes["harmindra-international"].card,
    meltwater: projectThemes.meltwater.card,
    jiffy: projectThemes.jiffy.card,
  },
};

module.exports = { colors, getProjectTheme };
